import Vue from "vue";
import Vuex from "vuex";
import userStore from "./modules/user";
import homeStore from "./modules/home";
import chatStore from "./modules/chat";
import expandStore from "./modules/expand";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    chat: chatStore,
    user: userStore,
    home: homeStore,
    expand: expandStore,
  },
});

export default store;
